import WorkflowApi from '../../api/workflow/workflow'
import ElementUI from 'element-ui';

export default {

    namespaced: true,

    state: {

        requestWorkflowInfo: {

       }

    },

    getters: {

        requestWorkflowInfo(state) {
            return state.requestWorkflowInfo;
        },

    },

    mutations: {

        changeRequestWorkflowInfo(state, payload) {
            state.requestWorkflowInfo = payload;
        },

    },

    actions: {

    },

}